import router from './router'
import store from './store'
import qs from 'qs'
import NProgress from 'nprogress' 
import 'nprogress/nprogress.css'
import { Message } from 'element-ui'
import { getToken,getLoginName, getLoginPwd,getLoginCompanyid} from '@/utils/auth' // 验权
import {  CheckRight } from '@/api/global'

const whiteList = ['/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start()


  if (getToken()) { //&& getLoginName() && getLoginPwd()

    if (to.path === '/login') {
      next({ path: '/quoteQuery/Query'})
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      // var redirectMsg = "页面从'"+from.meta.title+"'跳转到'"+to.meta.title+"'" ;
      // Message.warning(redirectMsg)
      if(Object.keys(store.getters.userInfo).length < 1) //刷新后vuex丢失，重新获取数据
      {
        store.dispatch('Login', {
          username:getLoginName(),
          password:getLoginPwd(),
          companyid:getLoginCompanyid()
        }).then(() => {
          // if(CheckRight(to.meta.limitName,1))
          // {
          //   next()
          // }
          // else
          // {
          //   Message.warning("无'"+to.meta.title+"'页面的查看权限")
          //   next(false)
          // }
          next();
        }).catch((err) => {
          store.dispatch('LogOut').then(() => {
            next({ path: '/login' })
          })
        })
      }
      else
      {
          // if(CheckRight(to.meta.limitName,1))
          // {
          //   next()
          // }
          // else
          // {
          //   Message.warning("无'"+to.meta.title+"'页面的查看权限")
          //   next(false)
          // }
          next();
      }
    }
    
  } else { //没有获取到token 
    if (whiteList.indexOf(to.path) !== -1) {
      //是白名单页面，直接进入到白名单页面
      next()
    } else {
      //20190322 新增判断,是erpLogin话就直接next
      if(to.path === "/erpLogin"){
        next()
      }else{
        //不是白名单页面，跳转到登录页面
        next('/login')
        NProgress.done()
      } 
    }
  }
  NProgress.done()
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js